/* eslint-disable max-len */
import * as React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const DoubleCheck = (props: Props) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.8926 5.45205C17.1786 5.15253 17.6526 5.14168 17.9521 5.42764C18.2517 5.71369 18.2626 6.18764 17.9766 6.48721L10.0391 14.7997C9.89403 14.9516 9.69238 15.0362 9.48242 15.0321C9.27245 15.028 9.07352 14.9357 8.93457 14.7782L7.99707 13.7157C7.72323 13.4051 7.75296 12.9311 8.06348 12.6571C8.37404 12.3832 8.84804 12.4131 9.12207 12.7235L9.51855 13.1728L16.8926 5.45205ZM12.4971 5.22353C12.7711 4.91302 13.2451 4.88329 13.5557 5.15713C13.8662 5.43114 13.896 5.90513 13.6221 6.21572L6.12207 14.7157C5.97846 14.8785 5.77077 14.9712 5.55371 14.9696C5.33693 14.9679 5.13137 14.8725 4.99023 14.7079L1.99023 11.2079C1.72081 10.8935 1.75698 10.4199 2.07129 10.1503C2.3857 9.8808 2.8593 9.91709 3.12891 10.2313L5.56738 13.0761L12.4971 5.22353Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default DoubleCheck;
